module.exports = __webpack_public_path__ + "static/media/ic_merge_hover.f3c9509c.svg";